import * as types from './types';

export const state = {
  resultCount: 0,
  searchFilter: '',
  searchResults: [],
};

export const mutations = {
  [types.SET_SEARCH_FILTER](state, searchFilter) {
    state.searchFilter = searchFilter;
  },
  [types.SET_SEARCH_RESULTS](state, searchResults) {
    state.searchResults = searchResults;
  },
  [types.SET_COUNT](state, count) {
    state.resultCount = count;
  },
  [types.APPEND_RESULT](state, results) {
    state.searchResults = [...state.searchResults, ...results];
  },
  [types.RESET_SEARCH_FILTER](state) {
    state.searchFilter = '';
  },
};



// WEBPACK FOOTER //
// ./src/screens/Search/store/mutations.js